const noop = () => {};

export const socket = {
  auth: {},
  id: "",
  connect: noop,
  disconnect: noop,
  on: noop,
  off: noop,
  emit: noop
};
